<style lang="scss" scoped>
  @import "./auth.scss";
</style>
<script>
import { CONSTANT,
  AUTH_FLOW_OPTIONS,
  AUTH_PRESENTATION_OPTIONS, AUTH_DPA_DATA, MDES_FLOW_OPTIONS, SCOF_API_LEVEL_CONFIG_OPTIONS, LOCALES } from '../../../utils/constant.js'
import ConfigurationService from '../configuration.service'
import '../../../utils/custome-validator'
import JsonEditorComponent from '../../shared/json-editor/json-editor.vue'
import { mapGetters } from 'vuex'
import sharedService from '@/utils/shared-service'
import toasterService from '../../../utils/toaster'
import utils from '../../../utils/utils'

const configurationService = new ConfigurationService()

export default {
  name: 'Auth',
  components: {
    JsonEditorComponent
  },
  data () {
    return {
      CONSTANT: CONSTANT,
      configurationService: configurationService,
      authExecutionFlowOptions: AUTH_FLOW_OPTIONS,
      scofApiLevelConfigOptions: SCOF_API_LEVEL_CONFIG_OPTIONS,
      authPresentationOptions: AUTH_PRESENTATION_OPTIONS,
      mdesExecutionFlowOptions: MDES_FLOW_OPTIONS,
      AUTH_DPA_DATA: AUTH_DPA_DATA,
      authDpaDataSTR: {},
      isDataEdited: true,
      isLMCEnabled: false,
      isSTFEnabled: false,
      isSPLEnabled: false,
      isNTSEnabled: false,
      isFA2Enabled: false,
      isICTEnabled: false,
      isENCEnabled: false,
      isScofOtherLocale: false,
      scofOtherLocale: this.value,
      localeValidationError: false,
      locales: LOCALES,
      complianceSettings: {},
      complianceSettingsSTR: null,
      iscomplianceEdited: false
    }
  },
  computed: {
    ...mapGetters(['authDpaData', 'environment', 'toggleMacsFeaturesList', 'c2pSelectedCurrency', 'complianceSettingsCITObj']),

    enableB2bAuthLookupFIDO: {
      get () {
        return this.$store.getters.enableB2bAuthLookupFIDO
      },
      set (value) {
        this.$store.commit('setEnableB2bAuthLookupFIDO', value)
      }
    },

    enableNativeIntegrationFlow: {
      get () {
        return this.$store.getters.enableNativeIntegrationFlow
      },
      set (value) {
        this.selectedMDESFlow = 'B2B_API_FLOW'
        this.$store.commit('setEnableNativeIntegrationFlow', value)
      }
    },

    enableB2bAuthenticate: {
      get () {
        return this.$store.getters.enableB2bAuthenticate
      },
      set (value) {
        this.$store.commit('setEnableB2bAuthenticate', value)
      }
    },

    enableENCFlow: {
      get () {
        return this.$store.getters.enableENCFlow
      },
      set (value) {
        this.$store.commit('setEnableENCFlow', value)
      }
    },

    enableTokenizationConsent: {
      get () {
        return this.$store.getters.enableTokenizationConsent
      },
      set (value) {
        this.$store.commit('setEnableTokenizationConsent', value)
      }
    },

    selectedAuthFlow: {
      get () {
        return this.$store.getters.authExecutionFlow
      },
      set (value) {
        this.$store.commit('setAuthExecutionFlow', value)
      }
    },

    selectedForceChallenge: {
      get () {
        return this.$store.getters.forceChallenge
      },
      set (value) {
        this.$store.commit('setForceChallenge', value)
      }
    },

    selectedRegion: {
      get () {
        return this.$store.getters.region
      },
      set (value) {
        value === CONSTANT.REGION.GLOBAL ? this.$store.commit('changeCurrency', this.c2pSelectedCurrency) : this.$store.commit('changeCurrency', CONSTANT.SCOF_CURRENCY[value])
        this.$store.commit('setRegion', value)
        this.setAuthDpaDataConfig()
        this.loadAuthSDK()
      }
    },

    selectedAuthExp: {
      get () {
        return this.$store.getters.authPresentationStyle
      },
      set (value) {
        this.$store.commit('setAuthPresentationExp', value)
      }
    },

    selectedMDESFlow: {
      get () {
        return this.$store.getters.mdesExecutionFlow
      },
      set (value) {
        this.$store.commit('setMdesExecutionFlow', value)
      }
    },

    b2bAuthLookupReason: {
      get () {
        return this.$store.state.configuration.auth.b2bAuthLookupReason
      }
    },
    /**
     * ------C2P configuration------------
     */

    authenticationMethodTypes: {
      get () {
        return this.$store.state.configuration.auth.authenticationMethodTypes
      }
    },

    suppressChallenge: {
      get () {
        return this.$store.state.configuration.auth.suppressChallenge
      },
      set (value) {
        this.$store.dispatch('updateSuppressChallenge', value)
      }
    },

    payloadRequested: {
      get () {
        return this.$store.state.configuration.auth.payloadRequested
      },
      set (value) {
        this.$store.dispatch('updatePayloadRequested', value)
      }
    },

    acquirerData: {
      get () {
        return this.$store.state.configuration.auth.acquirerData
      },
      set (value) {
        this.$store.dispatch('updateAcquirerData', value)
      }
    },

    authPreference: {
      get () {
        return this.$store.state.configuration.auth.authPreference
      },
      set (value) {
        this.$store.dispatch('updateAuthPreference', value)
      }
    },

    scofLocale: {
      get () {
        return this.$store.state.configuration.scofLocale || 'en_US'
      },
      set (value) {
        this.$store.commit('changeScofLocale', value)
        this.$store.commit('changeScofOtherLocale', '')
      }
    },

    authenticationFactors: {
      get () {
        return this.$store.state.configuration.authenticationFactors
      },
      set (value) {
        this.$store.commit('setAuthenticationFactors', value)
      }
    }
  },

  watch: {
    toggleMacsFeaturesList () {
      this.isLMCEnabled = sharedService.checkFeatureFlag('START_LMC_CHANGES')
      this.isSPLEnabled = sharedService.checkFeatureFlag('START_SPL_CHANGES')
      this.isNTSEnabled = sharedService.checkFeatureFlag('START_NTS_CHANGES')
      this.isFA2Enabled = sharedService.checkFeatureFlag('START_FA2_CHANGES')
      this.isICTEnabled = sharedService.checkFeatureFlag('START_ICT_CHANGES')
      this.isENCEnabled = sharedService.checkFeatureFlag('START_ENC_CHANGES')
      if (this.isNTSEnabled === false) {
        this.$store.commit('setEnableNativeIntegrationFlow', false)
      }
    },
    scofLocale () {
      this.selectLocale(this.scofLocale)
    }
  },
  mounted () {
    this.selectLocale(this.scofLocale)
    if (this.enableNativeIntegrationFlow === true && this.selectedMDESFlow === 'HOSTED_UI_FLOW') {
      this.selectedMDESFlow = 'B2B_API_FLOW'
    }
  },

  created () {
    this.isLMCEnabled = sharedService.checkFeatureFlag('START_LMC_CHANGES')
    this.isSPLEnabled = sharedService.checkFeatureFlag('START_SPL_CHANGES')
    this.isNTSEnabled = sharedService.checkFeatureFlag('START_NTS_CHANGES')
    this.isFA2Enabled = sharedService.checkFeatureFlag('START_FA2_CHANGES')
    this.isICTEnabled = sharedService.checkFeatureFlag('START_ICT_CHANGES')
    this.isENCEnabled = sharedService.checkFeatureFlag('START_ENC_CHANGES')
    this.authDpaDataSTR = this.authDpaData
    this.isDataEdited = true
    if (this.environment !== CONSTANT.CONFIG.ENVIRONMENT.SANDBOX) {
      this.$store.commit('setRegion', CONSTANT.REGION.GLOBAL)
    }
    this.complianceSettings = this.complianceSettingsCITObj
    this.complianceSettingsSTR = JSON.stringify(this.complianceSettings, undefined, 4)
    this.refresh(false)
    this.setAuthDpaDataConfig()
  },
  methods: {

    loadAuthSDK () {
      this.$store.dispatch('updateEnableAuthSDKFlow', true).then(res => {
      }).catch(err => {
        this.$store.dispatch('updateEnableAuthSDKFlow', false)
        toasterService.onFailure(err)
      })
    },

    updateRequestParam (updatedData) {
      const authDpaDataKey = this.selectedRegion === CONSTANT.REGION.GLOBAL ? this.environment : (this.environment).concat('_', this.selectedRegion)
      this.authDpaDataSTR = updatedData
      let authDpaData = this.$store.getters.authDpaData
      authDpaData[authDpaDataKey] = updatedData
      this.$store.commit('setAuthDpaData', authDpaData)
    },

    updateComplianceSettingsObj () {
      this.iscomplianceEdited = true
      if (utils.isJsonString(this.complianceSettingsSTR)) {
        this.complianceSettings = JSON.parse(this.complianceSettingsSTR)
        this.$store.commit('updateComplianceSettingsCITObj', this.complianceSettings)
      } else {
        if (this.complianceSettingsSTR.trim() === '') {
          this.$store.commit('updateComplianceSettingsCITObj', {})
        }
      }
    },

    setAuthDpaDataConfig () {
      const authDpaDataKey = this.selectedRegion === CONSTANT.REGION.GLOBAL ? this.environment : (this.environment).concat('_', this.selectedRegion)
      setTimeout(() => {
        let authDpaData = this.$store.getters.authDpaData
        authDpaData[authDpaDataKey] = authDpaData[authDpaDataKey] ? authDpaData[authDpaDataKey] : this.AUTH_DPA_DATA[authDpaDataKey]
        this.$store.commit('setAuthDpaData', authDpaData)
        this.authDpaDataSTR = this.authDpaData[authDpaDataKey]
      }, 100)
    },

    toggleTransactionAuthMethods (key, $event) {
      if (key === null && $event.target.checked) {
        const obj = Object.assign({}, ...Object.keys(this.authenticationMethodTypes).map(key => ({ [key]: key === 'null' })))
        this.$store.commit('setAuthenticationMethodTypes', obj)
      } else {
        this.authenticationMethodTypes['null'] = false
        this.authenticationMethodTypes[key] = $event.target.checked
        this.$store.commit('setAuthenticationMethodTypes', this.authenticationMethodTypes)
      }
    },

    toggleAuthB2BLookupReason (key, $event) {
      Object.keys(CONSTANT.CONFIG.B2B_LOOKUP_REASON).forEach((item) => {
        if (item !== key) {
          this.b2bAuthLookupReason[item] = false
        } else {
          this.b2bAuthLookupReason[key] = true
        }
      })
      this.$store.commit(
        'setB2bAuthLookupReason',
        this.b2bAuthLookupReason
      )
    },

    /**
     * select locale and check for Others
     * @param selectedLocale
     */
    selectLocale (selectedLocale) {
      this.localeValidationError = false
      if (selectedLocale === CONSTANT.CONFIG.OTHER_LOCALE) {
        this.isScofOtherLocale = true
      } else {
        this.isScofOtherLocale = false
        this.$store.commit('changeOtherLocale', '')
      }
      this.scofOtherLocale = this.$store.getters.scofOtherLocale || ''
    },

    /**
     * check preferred locale and update if valid
     * @param locale
     */
    checkValidLocale (locale) {
      const validLocale = this.validateLocale(locale)
      if (validLocale) {
        this.$store.commit('changeScofOtherLocale', locale)
      } else {
        this.$store.commit('changeScofOtherLocale', '')
      }
    },

    /**
     * validate input preferred locale
     * @param preferredLocale
     * @return boolean
     */
    validateLocale (preferredLocale) {
      const pattern = /^[a-z]{2}_[A-Z]{2}$/
      if (!pattern.test(preferredLocale)) {
        this.localeValidationError = true
        return false
      } else {
        this.localeValidationError = false
        return true
      }
    },

    refresh (isResetClick) {
      let complainceICTObj = JSON.parse(JSON.stringify(this.configurationService.getDefaultComplainceObject()))
      let defaultCardHolderTimestamp = complainceICTObj.complianceSettings.tokenization.cardHolderConsentCapturedTimestamp
      let cardHolderTimestamp = this.complianceSettings.complianceSettings.tokenization.cardHolderConsentCapturedTimestamp
      if (utils.isDateAndTimeEqual(defaultCardHolderTimestamp, cardHolderTimestamp) || isResetClick) {
        complainceICTObj.complianceSettings.tokenization.cardHolderConsentCapturedTimestamp = new Date().toISOString()
        complainceICTObj.assuranceData.verificationData[0].verificationTimestamp = Math.floor(new Date() / 1000)
        this.$store.commit('updateComplianceSettingsCITObj', complainceICTObj)
        this.complianceSettingsSTR = JSON.stringify(complainceICTObj, undefined, 4)
      }
    }
  }
}
</script>
<template>
  <div id="configuration-auth">
    <div class="card mb-4">
      <h5
        aria-controls="authSDKPanel"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#authSDKPanel"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('label.authSDKPanelHeader') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>

      <div
        id="authSDKPanel"
        class="card-body collapse show"
      >
        <div
          v-if="isNTSEnabled"
          class="alert alert-info mt-3"
          role="alert">
          <div class="d-flex align-items-center gap-2">
            <div>
              <i
                class="fa fa-info-circle fa-2x"
                aria-hidden="true"/>
            </div>
            <div class="ml-2">
              <p class="mb-0">
                <span>{{ $t("label.ntsIntegrationFlowInfo") }}</span>
              </p>
            </div>
          </div>
        </div>
        <h5 class="mb-3">
          {{ $t('header.tokenAuthenticationConfigHeading') }}
        </h5>
        <div
          v-if="environment === CONSTANT.CONFIG.ENVIRONMENT.SANDBOX"
          class="d-flex justify-content-start mb-3 gap-2">
          <div
            v-for="option in scofApiLevelConfigOptions"
            :key="option.value"
            class="form-check ml-2"
          >
            <input
              :id="option.value"
              v-model="selectedRegion"
              :value="option.value"
              class="form-check-input"
              type="radio"
              name="scofConfigOptions"
            >
            <label
              :for="option.value"
              class="form-check-label ml-1"
            >
              {{ option.key }}
            </label>
          </div>
        </div>
        <div class="form-group row ml-2">
          <div
            class="form-check form-check-inline"
          >
            <input
              id="enableB2bAuthLookup"
              v-model="enableB2bAuthLookupFIDO"
              data-test="enableB2bAuthLookup"
              class="form-check-input"
              type="checkbox"
            >
            <label
              for="enableB2bAuthLookup"
              class="form-check-label">{{ $t ('label.enableB2BAuthLookupFIDO') }}
            </label>
          </div>
          <div
            v-if="isNTSEnabled"
            class="form-check form-check-inline"
          >
            <input
              id="enableNativeIntegrationFlow"
              v-model="enableNativeIntegrationFlow"
              data-test="enableNativeIntegrationFlow"
              class="form-check-input"
              type="checkbox"
            >
            <label
              for="enableNativeIntegrationFlow"
              class="form-check-label">{{ $t ('label.enableNativeIntegrationFlow') }}
            </label>
          </div>
        </div>
        <div
          v-if="enableB2bAuthLookupFIDO"
          id="selectAuthB2BLookupReason"
          class="mt-3 mb-3">
          <fieldset class="radio-group">
            <legend class="form-check-label">{{ $t("label.selectAuthReasonForB2BLookup") }}</legend>
            <div
              id="b2b-lookup-reason"
              class="ml-2">
              <div
                v-for="(key, value) in CONSTANT.CONFIG.B2B_LOOKUP_REASON"
                :key="key"
                class="form-check form-check-inline"
              >
                <input
                  :id="'inlineRadio' + key"
                  :checked="b2bAuthLookupReason[key]"
                  :data-test="'radio-' + key"
                  class="form-check-input"
                  type="radio"
                  name="b2bAuthLookupReason"
                  @click="toggleAuthB2BLookupReason(key, $event)"
                >
                <label
                  :for="'inlineRadio' + key"
                  class="form-check-label"
                >{{ value }}</label>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="form-group row ml-2">
          <div
            v-if="isFA2Enabled"
          >
            <div class="form-check form-check-inline">
              <input
                id="enableB2bAuthenticate"
                v-model="enableB2bAuthenticate"
                data-test="enableB2bAuthenticate"
                class="form-check-input"
                type="checkbox"
              >
              <label
                for="enableB2bAuthenticate"
                class="form-check-label">{{ $t ('label.enableB2BAuthenticate') }}
              </label>
            </div>
          </div>
          <div
            v-if="isENCEnabled"
          >
            <div class="form-check form-check-inline">
              <input
                id="enableENCFlow"
                v-model="enableENCFlow"
                data-test="enableENCFlow"
                class="form-check-input"
                type="checkbox"
              >
              <label
                for="enableENCFlow"
                class="form-check-label">{{ $t ('label.enableENCFlow') }}
              </label>
            </div>
          </div>
        </div>
        <div class="ml-2">
          <label>{{ $t ('label.authExecutionFlowLabel') }}</label>
          <div
            v-for="authExecutionFlow in authExecutionFlowOptions"
            :key="authExecutionFlow.value"
            class="form-check ml-2"
          >
            <input
              :id="authExecutionFlow.value"
              v-model="selectedAuthFlow"
              :value="authExecutionFlow.value"
              class="form-check-input"
              type="radio"
              name="authExecutionFlowselection"
            >
            <label
              :for="authExecutionFlow.value"
              class="form-check-label ml-1"
            >
              {{ authExecutionFlow.key }}
            </label>
            <div class="clear" />
          </div>
        </div>
        <h5 class="mt-3 mb-3">
          {{ $t('header.MDESIDVConfigLabel') }}
        </h5>
        <div class="ml-2">
          <label>{{ $t ('label.authExecutionFlowLabel') }}</label>
          <div
            v-for="mdesExecutionFlow in mdesExecutionFlowOptions"
            :key="mdesExecutionFlow.key"
            class="form-check ml-2"
          >
            <input
              :id="mdesExecutionFlow.key"
              :disabled="enableNativeIntegrationFlow && isNTSEnabled"
              v-model="selectedMDESFlow"
              :value="mdesExecutionFlow.key"
              class="form-check-input"
              type="radio"
              name="mdesExecutionFlowselection"
            >
            <label
              :for="mdesExecutionFlow.key"
              class="form-check-label ml-1"
            >
              {{ mdesExecutionFlow.value }}
            </label>
            <div class="clear" />
          </div>
        </div>
        <div class="mt-3">
          <label>{{ $t ('label.authPresentationLabel') }}</label>
          <div
            v-for="authPresentationExp in authPresentationOptions"
            :key="authPresentationExp.value"
            class="form-check ml-2"
          >
            <input
              :id="authPresentationExp.value"
              v-model="selectedAuthExp"
              :value="authPresentationExp.value"
              class="form-check-input"
              type="radio"
              name="authPresentationExp"
            >
            <label
              :for="authPresentationExp.value"
              class="form-check-label ml-1"
            >
              {{ authPresentationExp.key }}
            </label>
            <div class="clear" />
          </div>
          <label class="mt-3">{{ $t ('label.selectForceChallenge') }}</label>
          <div id="faceCallange">
            <div
              v-for="(key, value) in CONSTANT.CONFIG.FORCE_CHALLENGE_OPTIONS"
              :key="value"
              class="form-check form-check-inline"
            >
              <input
                :id="'inlineRadio' + key"
                v-model="selectedForceChallenge"
                :data-test="'radio-' + key"
                :value="key"
                name="faceCallange"
                class="form-check-input"
                type="radio"
              >
              <label
                :for="'inlineRadio' + key"
                class="form-check-label"
              >
                {{ value }}
              </label>
            </div>
          </div>
        </div>
        <div
          v-if="isSPLEnabled"
          class="mt-4">
          <label>{{ $t ('label.authenticationFactorLabel') }}</label>
          <input
            id="input-authentication-factor"
            v-model="authenticationFactors"
            class="form-control"
            data-test="input-authentication-factor"
            type="text"
          >
        </div>
        <div class="mt-4">
          <label
            for="inlineCheckbox"
            class="form-check-label">{{ $t ('label.authDpaDataLabel') }}</label>

          <json-editor-component
            :json-data="authDpaDataSTR"
            :is-edited="!isDataEdited"
            :row-count="7"
            :enable-editing="false"
            @jsonDataUpdated="updateRequestParam"
          />
        </div>
        <div class="mt-4">
          <label
            for="localeSelected"
          >{{ $t('label.locale') }}</label>
          <div>
            <select
              id="localeSelected"
              v-model="scofLocale"
              class="form-control"
              data-test="locale"
              @change="selectLocale(scofLocale)"
            >
              <option
                v-for="localeObj in locales"
                :key="localeObj.label"
                :disabled="localeObj.separator"
                :value="localeObj.value"
              >
                {{ localeObj.label }}
              </option>
            </select>
          </div>
          <div class="ml-auto mt-2">
            <input
              v-if="isScofOtherLocale"
              id="preferredLocale"
              v-model.trim="scofOtherLocale"
              :class="{'border-danger': localeValidationError}"
              class="form-control float-left"
              data-test="preferredLocale"
              placeholder="Preferred Locale"
              type="text"
              @blur="checkValidLocale(scofOtherLocale)"
            >
            <p
              v-if="localeValidationError"
              id="localeValidationError"
              class="text-danger control-label mt-2"
            >
              {{ $t('errorMessages.invalidLocale') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isLMCEnabled"
      class="card mb-4">
      <h5
        id="headingLiabilityShift"
        aria-controls="collapseLiabilityShift"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#collapseLiabilityShift"
        data-test="3DS-preference-collapse"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('header.liabilityShiftTFAHeading') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>

      <div
        id="collapseLiabilityShift"
        aria-labelledby="headingLiabilityShift"
        class="card-body collapse"
      >
        <div
          class="alert alert-info mt-3"
          role="alert">
          <div class="d-flex align-items-center gap-2">
            <div>
              <i
                class="fa fa-info-circle fa-2x"
                aria-hidden="true"/>
            </div>
            <div class="ml-2">
              <p class="mb-0">
                <span>{{ $t("label.LMC_INFO") }}</span>
              </p>
            </div>
          </div>
        </div>
        <div
          id="authPreferenceId"
          class="mt-3">
          <label>{{ $t("label.authenticationPreferenceLabel") }}</label>
          <div
            id="auth-preference-id"
            class="ml-2">
            <div
              v-for="(key, value) in CONSTANT.CONFIG.SUPPRESS_CHALLENGE"
              :key="value"
              class="form-check form-check-inline"
            >
              <input
                :id="'inlineRadio' + key"
                v-model="authPreference"
                :data-test="'radio-' + key"
                :value="key"
                name="authPreference"
                class="form-check-input"
                type="radio"
              >
              <label
                :for="'inlineRadio' + key"
                class="form-check-label"
              >
                {{ value }}
              </label>
            </div>
          </div>
        </div>
        <div
          id="payloadRequestedId"
          class="mt-3">
          <label>{{ $t("label.payloadRequestedLabel") }}</label>
          <div
            id="payload-requested-id"
            class="ml-2">
            <div
              v-for="(key, value) in CONSTANT.CONFIG.PAYLOAD_REQUESTED"
              :key="value"
              class="form-check form-check-inline"
            >
              <input
                :id="'inlineRadio' + key"
                v-model="payloadRequested"
                :data-test="'radio-' + key"
                :value="key"
                name="payloadRequested"
                class="form-check-input"
                type="radio"
              >
              <label
                :for="'inlineRadio' + key"
                class="form-check-label"
              >
                {{ value }}
              </label>
            </div>
          </div>
        </div>
        <div
          id="dpaTAMethodTypes"
          class="mt-3">
          <label>{{ $t("label.authMethodTypeLabel") }}</label>
          <div
            id="dpa-transaction-methods"
            class="ml-2">
            <div
              v-for="(key, value) in CONSTANT.CONFIG.AUTHENTICATION_METHOD_TYPES"
              :key="key"
              class="form-check form-check-inline"
            >
              <input
                :id="'inlineCheckbox' + key"
                :checked="authenticationMethodTypes[key]"
                :data-test="'checkbox-' + key"
                class="form-check-input"
                type="checkbox"
                @click="toggleTransactionAuthMethods(key, $event)"
              >
              <label
                :for="'inlineCheckbox' + key"
                class="form-check-label">{{
                  value
                }}</label>
            </div>
          </div>
        </div>
        <div
          id="dpaTAChallenge"
          class="mt-3">
          <label>{{ $t("label.suppressChallengeLabel") }}</label>
          <div
            id="dpa-suppress-challenge"
            class="ml-2">
            <div
              v-for="(key, value) in CONSTANT.CONFIG.SUPPRESS_CHALLENGE"
              :key="value"
              class="form-check form-check-inline"
            >
              <input
                :id="'inlineRadio' + key"
                v-model="suppressChallenge"
                :data-test="'radio-' + key"
                :value="key"
                name="suppressChallenge"
                class="form-check-input"
                type="radio"
              >
              <label
                :for="'inlineRadio' + key"
                class="form-check-label"
              >
                {{ value }}
              </label>
            </div>
          </div>
        </div>
        <div
          class="form-check form-check-inline mt-3"
        >
          <input
            id="acquirerDataid"
            v-model="acquirerData"
            data-test="acquirerData"
            class="form-check-input"
            type="checkbox"
          >
          <label
            for="acquirerDataid"
            class="form-check-label">{{ $t ('label.acquirerDataLabel') }}
          </label>
        </div>
      </div>
    </div>
    <div
      v-if="isICTEnabled"
      class="card mb-4">
      <h5
        id="headingTokenizationConsent"
        aria-controls="collapseTokenizationConsent"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#collapseTokenizationConsent"
        data-test="ICT-preference-collapse"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('header.tokenizationConsent') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>

      <div
        id="collapseTokenizationConsent"
        aria-labelledby="headingTokenizationConsent"
        class="card-body collapse"
      >
        <div class="form-check form-check-inline">
          <input
            id="enableTokenizationConsent"
            v-model="enableTokenizationConsent"
            data-test="enableTokenizationConsent"
            class="form-check-input"
            type="checkbox"
          >
          <label
            for="enableTokenizationConsent"
            class="form-check-label">{{ $t ('label.enableTokenizationConsent') }}
          </label>
        </div>
        <div class="mt-4">
          <div class="d-flex justify-content-between pb-1">
            <label
              for="inlineCheckbox"
              class="form-check-label pt-3">{{ $t ('label.complianceSettingsAndAssuranceData') }}</label>
            <button
              id="generate-btn"
              class="btn btn-primary"
              type="button"
              @click="refresh(true)"
            >
              {{ $t ('label.refresh') }}
            </button>
          </div>
          <textarea
            v-validate="{ validJson: true }"
            v-model="complianceSettingsSTR"
            :disabled="!enableTokenizationConsent"
            :class="{ 'is-invalid': errors.has('complianceSettings') }"
            class="form-control"
            rows="20"
            cols="67"
            name="complianceSettings"
            placeholder=""
            @input="updateComplianceSettingsObj(errors.has('complianceSettings'))"
          />
          <span
            v-if="iscomplianceEdited && errors.has('complianceSettings')"
            class="invalid-feedback"
          >{{ errors.first("complianceSettings") }}
          </span>

        </div>
      </div>
    </div>
  </div>
</template>
